
export default [
  {
    name:"Expense Management",
    path: '/expenseMansgement/index',
    component: (resolve) => require(['@/views/expenseMansgement/index'], resolve),
    meta: { title: 'Expense Management', noCache: false, affix: false },
    roles:[0,9]
  },

]
